import styled, { css } from 'styled-components'
import Tooltip from '../../../../components/Tooltip'

interface ButtonProps {
  desktop?: boolean
}

export const Container = styled.div`
  height: auto;

  background: linear-gradient(177deg, #055175 0%, #041821 100%);
  padding-top: 22px;
  padding-bottom: 100px;

  @media only screen and (min-width: 1050px) {
    height: 250px;
    padding-top: 0px;
  }
`

export const Wrapper = styled.div`
  max-width: 1200px;
  width: 90%;
  height: 100%;

  margin: 0 auto;
  position: relative;

  display: flex;
  flex-direction: column;

  @media only screen and (min-width: 1050px) {
    flex-direction: row;
    align-items: flex-start;
  }
`

export const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 3.5rem;
  height: 3.5rem;

  padding: 0.5rem;

  border-radius: 6px;
  background: #fff;

  @media only screen and (min-width: 1050px) {
    width: 4.5rem;
    height: 4.5rem;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  padding: 1rem 0;

  @media only screen and (min-width: 1050px) {
    height: 100%;

    justify-content: center;

    padding: 0;
  }
`

export const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-width: 0;

  display: flex;
  flex-direction: column;
  justify-content: center;

  padding: 0;

  @media only screen and (min-width: 1050px) {
    margin-top: 20px;
    padding: 6px 20px;
    gap: 5px;
  }

  span {
    color: #fff;
    margin-bottom: 0.5rem;
  }

  button {
    background: none;
    border: none;
    color: #ff6600;
    width: 6rem;
    cursor: pointer;
  }
`

export const DescriptionLesson = styled.div`
  h1 {
    padding-top: 10px;
    margin: 0 0 1rem 0;
    color: rgba(249, 249, 249, 1);
    font-size: 1.625rem;
    font-weight: 700;
  }

  h2 {
    margin: 0;
    color: #f9f9f9;
    font-size: 1.3rem;
    font-weight: 300;
  }

  p {
    margin: 0;
    color: #bababa;
    font-size: 1rem;
    line-height: 1.4375rem;
    font-weight: 400;
  }

  @media only screen and (min-width: 1050px) {
    h1 {
      padding-top: 10px;
      color: rgba(249, 249, 249, 1);
      font-size: 1.625rem;
      font-weight: 700;
    }
  }
`

export const TeacherContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;

  .teacherInfo {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
  }

  .photoContainer {
    display: flex;
  }

  .photoWrapper {
    display: flex;
    justify-content: center;
    align-items: center;

    margin-right: -0.6rem;

    &:hover {
      z-index: 100;
    }
  }

  .teacher_name {
    font-size: 1rem;
    color: rgba(249, 249, 249, 1);

    margin: 0;
  }

  button {
    padding: 0;
    width: initial;
  }

  .modal_teacher {
    display: grid;
    grid-template-columns: 3fr 3fr 3fr;
    width: 90%;
  }

  img {
    box-shadow: 1px 1px 1px 1px #222;
    min-width: 36px;
    min-height: 36px;
    max-width: 36px;
    max-height: 36px;

    object-fit: cover;

    border-radius: 50%;
  }

  @media only screen and (min-width: 1050px) {
  }
`

export const FormatWrapper = styled.div`
  display: flex;
  flex-direction: column;

  span {
    color: #bababa;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 400;
    margin: 1rem 0 0.5rem;
  }

  @media only screen and (min-width: 1050px) {
    display: none;
  }
`

export const FormatWrapperDesk = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto 0 0;

  span {
    color: #bababa;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 400;
    margin: 1rem 0 0.5rem;
  }

  @media only screen and (max-width: 900px) {
    display: none;
  }
`

export const SwitchButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  border: 2px solid rgba(255, 255, 255, 0.2);
  background: transparent;
  width: 39px;
  height: 39px;
  color: #fff;
  border-radius: 4px;
  width: 100%;

  color: #f9f9f9;
  font-size: 1rem;
  line-height: 1.4375rem;
  font-weight: 400;

  svg {
    margin-right: 1rem;
  }
`

export const ButtonDots = styled.button<ButtonProps>`
  ${(props) =>
    props.desktop &&
    css`
      margin-top: 2rem;
    `}
  border: 2px solid rgba(255, 255, 255, 0.2);
  background: transparent;
  padding: 0.5rem 1rem;

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-right: 0.5rem;
  }

  /* width: 39px;
    height: 39px; */
  color: #fff;
  border-radius: 4px;

  &:disabled {
    cursor: not-allowed;
  }
`

export const SwitchFormatDesk = styled.div`
  background: #1d4051;
  border-radius: 7px;
  margin-top: 80px;
  margin-left: -0.5rem;

  position: absolute;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.8rem 1rem;

    border: none;
    background: transparent;
    width: 39px;
    height: 39px;
    color: #fff;
    border-radius: 4px;
    width: 100%;

    color: #f9f9f9;
    font-size: 1rem;
    line-height: 1.4375rem;
    font-weight: 400;

    svg {
      margin-right: 1rem;
    }
  }

  @media only screen and (max-width: 900px) {
    display: none;
  }
`

export const SwitchFormat = styled.div`
  background: #1d4051;
  border-radius: 7px;
  width: calc(100% - 2rem);
  margin-top: 80px;

  position: absolute;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.8rem 1rem;

    border: none;
    background: transparent;
    width: 39px;
    height: 39px;
    color: #fff;
    border-radius: 4px;
    width: 100%;

    color: #f9f9f9;
    font-size: 1rem;
    line-height: 1.4375rem;
    font-weight: 400;

    svg {
      margin-right: 1rem;
    }
  }

  @media only screen and (min-width: 1050px) {
    display: none;
  }
`

export const ButtonContainerDesk = styled.div`
  position: absolute;
  top: 1rem;
  right: 0;

  width: 200px;

  display: flex;

  @media only screen and (min-width: 1050px) {
    position: static;
    margin: auto;
  }
`

export const CustomTooltip = styled(Tooltip)`
  //height: 20px;
  //margin-left: 16px;

  svg {
    margin: 0;
    width: 100%;
  }

  span {
    background: #fff;
    color: #333;
    left: 40%;
    transform: translateX(-60%);

    &::before {
      border-color: #fff transparent;
    }
  }
`

export const ButtonsWrapper = styled.div`
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;

  @media only screen and (min-width: 400px) {
    justify-content: space-between;
  }

  li {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      margin-left: 0.5rem;
    }
  }

  button {
    border: 1px solid #375665;
    background: transparent;
    border-radius: 4px;
    padding: 0.6rem 1rem;
    width: auto;
    height: 39px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;

    gap: 0.5rem;

    font-size: 0.875rem;
    line-height: 1rem;
    font-weight: 700;

    @media only screen and (min-width: 400px) {
      width: 200px;

      padding: 0.6rem 0.7rem;
    }
  }
`
export const MenuDropdown = styled.nav`
  position: absolute;
  top: 100%;
  width: auto;
  right: 0;
  background: #2c3751;
  color: #fff;
  border-radius: 10px;
  font-size: 0.8rem;

  margin-top: 0.5rem;

  ul {
    padding: 0;
    width: auto;
    min-width: 200px;
    list-style: none;
    li {
      padding: 10px;
      cursor: pointer;
      justify-content: flex-start;

      svg {
        margin-left: 0.5rem !important;
      }
      &:hover {
        background: #536181;
      }
      &.disabled {
        background: inherit;
        color: #8b8888;
        cursor: default;
      }
    }
  }
`

export const WrapperContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Modal = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => `rgb(${theme.background.high})`};
  min-width: 20rem;
  max-width: 50.62rem;
  max-height: 30rem;
  border-radius: 6px;
  padding: 1rem;

  hr {
    border: none;
    border-top: 1px solid ${({ theme }) => `rgb(${theme.component.accent})`};
  }
`

export const WrapperTeste = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 18rem;
  max-width: 60rem;
  font-weight: bold;

  h2 {
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
  }

  button {
    border: none;
    background-color: transparent;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
  }
`

export const ButtonsAnnotattion = styled.div`
  width: 100%;
  display: flex;
  border: none;
  justify-content: end;
  margin-top: 1rem;

  button {
    display: flex;
    justify-content: end;
    align-items: center;
    justify-content: center;
    width: 5.5rem;
    height: 2rem;
    border-radius: 5px;
    border: solid 0.1px rgba(186, 186, 186, 1);
    background-color: transparent;
  }
  .save-button {
    margin-left: 0.7rem;
    border-radius: 5px solid;
    background-color: #ff6600;
    color: white;
    border: none;
  }
`

export const GridTeacher = styled.div`
  display: grid;
  grid-template-columns: 3fr 3fr 3fr;
  align-items: flex-start;
  justify-content: flex-start;

  .name_photo {
    h4 {
      color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
      font-weight: 500;
      margin-right: 1rem;
      margin-left: 10px;
    }
    @media only screen and (max-width: 900px) {
      h4 {
        font-size: 1rem;
        width: 100%;
        margin-left: 5px;
      }
    }

    display: flex;
    align-items: center;
    justify-content: center;
  }
`
